// returns a string with type of notification or false if no notification should be sent

interface Thread {
	comments: Comment[]
}

interface Comment {
	message: string
	author: User
}

interface User {
	name: string
}

export default function getTypeOfNotification(
	thread: Thread,
	comment: Comment,
	username: string,
): string | false {
	console.log(`in getType username is ${username}`)
	if (comment.message.includes(`@${username}`)) {
		console.log("mentions you")
		return "Mentions you"
	} else if (thread.comments.length === 1) {
		console.log("new comment")
		return "New comment"
	} else {
		let replyToYou = false
		thread.comments.forEach((comment) => {
			if (comment.author.name === username) {
				replyToYou = true
				return "Replied to you"
			}
		})
		if (replyToYou) return "Replied to you"
		else return false
	}

	return false
}
